var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navbar",class:{ 'navbar--fixed' : _vm.mobileMenuVisible}},[_c('NavbarLogo',{attrs:{"brand":_vm.brand,"logoIcon":_vm.mainIcon}}),_c('NavbarMenu',{attrs:{"links":_vm.links},on:{"mobileMenuToggled":_vm.mobileMenuToggle}}),_c('div',{staticClass:"navbar__bg"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }